'use strict';

/**
 * Presents a country (modeled in the model as a string of it's iso2 code) as a fully localized name,
 * in both directions
 */
customerZone.directive('isoCountry', ['utils', 'isoCountriesService', function(utils, isoCountriesService){
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ctrl){
            ctrl.$parsers.push(function(value){
                return isoCountriesService.isoForCountry(value);
            });

            ctrl.$formatters.push(function (modelValue){
                if (!modelValue) return '';
                return isoCountriesService.countryForIso(modelValue);
            });
        }
    };
}]);
